





























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import App from '../App.vue'
import { ToolComData } from '../models/ToolComData'
import ErrorDialog from './ErrorDialog.vue'
import { EnumHelpers, CommandType } from '../helpers/EnumHelpers'
import { FailureResponseData } from '../models/FailureResponseData'
import ValidationErrorsCard from './ValidationErrorsCard.vue'
import ActionsCard from './ActionsCard.vue'
import TitleCard from './TitleCard.vue'

@Component({
  components: { ErrorDialog, ValidationErrorsCard, ActionsCard, TitleCard },
})
export default class CommandDialog extends App {
  get getTitle() {
    if (this.isValidEdit()) {
      return 'Edit ' + this.item.name
    } else {
      return 'Create New Command'
    }
  }
  @Prop({ default: false })
  public isShown!: boolean
  @Prop({ default: false })
  public isEdit!: boolean
  @Prop({ required: false })
  public item!: ToolComData

  private privateIsShown: boolean = false
  private errorDialogIsShown: boolean = false
  private failure: FailureResponseData = new FailureResponseData()

  private types: Array<string> = EnumHelpers.GetCommandTypes()

  private name: string = ''
  private assemblyName: string = ''
  private className: string = ''
  private shortName: string = ''
  private type: string = 'Other'
  private availabilityClassName: string = ''
  private toolTipText: string = ''
  private smallIconFileName: string = ''
  private largeIconFileName: string = ''
  @Watch('isShown')
  public onIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    this.privateIsShown = value
  }
  @Watch('privateIsShown')
  public onprivateIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    if (value) {
      this.setDefaultData()
      if (this.isValidEdit()) {
        this.name = this.item.name
        this.assemblyName = this.item.assemblyName
        this.className = this.item.className
        this.shortName = this.item.shortName
        this.availabilityClassName = this.item.availabilityClassName
        this.toolTipText = this.item.toolTipText
        this.type = EnumHelpers.GetCommandType(this.item.type, false)
        this.largeIconFileName = this.item.largeIconFileName
        this.smallIconFileName = this.item.smallIconFileName
      }
    } else {
      this.$emit('dialogClosed')
      this.loading = false
    }
  }

  public async commitChanges() {
    if (!this.checkForm()) {
      return
    }

    this.loading = true

    try {
      const res: ToolComData = new ToolComData(
        this.name,
        this.assemblyName,
        this.className,
        '',
        this.shortName,
        this.toolTipText,
        this.availabilityClassName,
        EnumHelpers.GetCommandTypeValue(this.type),
        this.largeIconFileName,
        this.smallIconFileName
      )

      const errorObject: Object = ''
      const errorsOccurred: boolean = false

      if (this.isValidEdit()) {
        this.$emit('editCom', this.item, res)
      } else {
        this.$emit('addCom', res)
      }
      this.privateIsShown = false
    } catch (e) {
      this.failure = new FailureResponseData(e.message)
      this.errorDialogIsShown = true
    }

    this.loading = false
  }

  public cancelled(item) {
    this.privateIsShown = false
    this.$emit('dialogCancelled')
  }

  private setDefaultData() {
    this.validationErrors = []
    this.name = ''
    this.assemblyName = ''
    this.className = ''
    this.shortName = ''
    this.type = 'Other'
    this.availabilityClassName = ''
    this.toolTipText = ''
    this.smallIconFileName = ''
    this.largeIconFileName = ''

    this.resetValidation()
  }

  private isValidEdit() {
    return this.isEdit && this.item !== undefined
  }

  private checkForm() {
    this.validationErrors = []

    const form: any = this.$refs.form
    if (form) {
      return form.validate()
    } else {
      if (!this.name) {
        this.validationErrors.push('Name is required.')
      }
      if (!this.assemblyName) {
        this.validationErrors.push('Assembly name is required.')
      }
      if (!this.className) {
        this.validationErrors.push('Class name is required.')
      }
      if (!this.type) {
        this.validationErrors.push('Type is required.')
      }
      if (!this.shortName) {
        this.validationErrors.push('Short name is required.')
      }
      if (!this.smallIconFileName) {
        this.validationErrors.push('Small icon file name is required.')
      }
      if (!this.largeIconFileName) {
        this.validationErrors.push('Large icon file name is required.')
      }

      return this.validationErrors.length === 0
    }
  }
}
